// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';

const GridIcon = ({ className, fill }) => {
  return (
    <svg
      className={`${className} grid-icon`}
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="6" height="6" fill={fill} />
      <rect x="7" width="6" height="6" fill={fill} />
      <rect y="7" width="6" height="6" fill={fill} />
      <rect x="7" y="7" width="6" height="6" fill={fill} />
    </svg>
  );
};

GridIcon.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
};

GridIcon.defaultProps = {
  fill: '#9B9B9B',
  className: '',
};

export default GridIcon;
